import React, { useEffect } from 'react';
import Web3 from 'web3'
import WalletConnectProvider from '@walletconnect/web3-provider'
import { useNavigate } from 'react-router-dom'

import Pages from './Pages';
import { alertPopup } from './pages/Home';

import AOS from 'aos';
import 'aos/dist/aos.css'

import { closePopup, setGlobalState, getGlobalState, useGlobalState } from './js/Main'
import { CroCoDudeContractABI, CroCoDudeContract } from './js/contracts'

/* ------------------------- Created By Alhaji (C.CODES)
                             IG: c.codes_ig
                               Twitter: CCODES_web----------------------------------------- */


const Loaddata = async() => {
  
  var web3 = new Web3(new Web3.providers.HttpProvider('https://data-seed-prebsc-1-s1.binance.org:8545'));
  setGlobalState('web3', web3);
  const contract = new web3.eth.Contract(CroCoDudeContractABI, CroCoDudeContract); 
  setGlobalState('contract', contract);
  var totalSupply = await contract.methods.totalSupply().call();
  setGlobalState('maxSupply', totalSupply);
  const nfts = [];
  for (let i = 1; i <= totalSupply; i++) {
    var uri, owner, reflection;
    try{
      uri = await contract.methods.tokenURI(i).call();
      owner = await contract.methods.ownerOf(i).call(); 
      reflection = await contract.methods.getReflectionBalance(i).call();
      reflection = web3.utils.fromWei(reflection);
    }catch{
      console.log("caught error")
      continue;
    }
    const metadata = await fetch(uri).then((res) => res.json());
    metadata["owner"] = owner;
    metadata["reflection"] = reflection;
    nfts.push(metadata);
  }
  setGlobalState('nfts', nfts);
}






 

function App() {
  Loaddata();
  
  


    
    
  useEffect(() => {
    AOS.init();
    AOS.refresh();
    if(window.ethereum){
      window.ethereum.on('accountsChanged', async function (accounts) {
        alertPopup("Switching Accounts!!..", "green", 10000);
        setGlobalState("connectedAccount", accounts[0]);
        var web3 = new Web3(new Web3.providers.HttpProvider('https://data-seed-prebsc-1-s1.binance.org:8545'));
        setGlobalState('web3', web3);
        const contract = new web3.eth.Contract(CroCoDudeContractABI, CroCoDudeContract); 
        setGlobalState('contract', contract);
        var reflection = await contract.methods.getReflectionBalances().call({ from: accounts[0] })
        reflection = web3.utils.fromWei(reflection);
        setGlobalState('reflection', reflection);
        alertPopup("Switched Accounts!!", "green", 2000);
      })
    }
  }, []);
  
  return (
    <>
      <Pages />
    </>
  );
}


export default App;
/* ------------------------- Created By Alhaji (C.CODES)
                             IG: c.codes_ig
                               Twitter: CCODES_web----------------------------------------- */
